export type LibraryItem = {
  id: string;
  title: string;
  summary: string;
  tags: string[];
  meta: string;
  status: string;
};

export type CharacterItem = {
  id: string;
  role: string;
  trait: string;
  detail: string;
  image: string;
};

export type FormatItem = {
  id: string;
  name: string;
  icon: string;
  carrier: string;
  feature: string;
  audience: string;
  tip: string;
  image: string;
};

export type StepItem = {
  id: string;
  step: string;
  title: string;
  detail: string;
};

export type UpdateItem = {
  id: string;
  date: string;
  category: string;
  title: string;
  detail: string;
};

export type FaqItem = {
  id: string;
  question: string;
  answer: string;
};

export const novelChapters: LibraryItem[] = [
  { id: "n1", title: "第一章 归乡的清晨", summary: "天刚亮，嫂子就起身张罗一家人的早饭，熟悉的灶台声里藏着多年未说的旧事。", tags: ["日常", "铺垫"], meta: "约 3200 字 · 连载中", status: "已更新" },
  { id: "n2", title: "第二章 屋檐下的灯火", summary: "入夜后堂屋的灯一直没灭，一家人围坐的沉默比争吵更让人心里发紧。", tags: ["家庭", "情感"], meta: "约 3400 字 · 连载中", status: "已更新" },
  { id: "n3", title: "第三章 一封旧信", summary: "整理阁楼时翻出的一封旧信，把一段被小心收起的往事重新带回台面。", tags: ["线索", "回忆"], meta: "约 3600 字 · 连载中", status: "已更新" },
  { id: "n4", title: "第四章 邻里之间", summary: "街坊的一句闲话掀起涟漪，嫂子用她一贯的方式把尴尬轻轻化解。", tags: ["人情", "群像"], meta: "约 3100 字 · 连载中", status: "已更新" },
  { id: "n5", title: "第五章 雨夜的等候", summary: "大雨突至，她在村口站了很久，等一个迟迟没有回音的人。", tags: ["悬念", "情绪"], meta: "约 3300 字 · 连载中", status: "已更新" },
  { id: "n6", title: "第六章 说不出口的话", summary: "关心到了嘴边又咽回去，两代人的表达方式在这一章正面碰撞。", tags: ["代际", "冲突"], meta: "约 3500 字 · 连载中", status: "已更新" },
  { id: "n7", title: "第七章 灶台边的和解", summary: "一顿家常饭让紧绷的关系松动了，热气腾腾的锅灶成了和解的地方。", tags: ["转折", "温暖"], meta: "约 3800 字 · 连载中", status: "已更新" },
  { id: "n8", title: "第八章 远行的决定", summary: "年轻人提出要去远方闯一闯，嫂子没有挽留，只是默默打点好行装。", tags: ["成长", "离别"], meta: "约 3400 字 · 连载中", status: "已更新" },
  { id: "n9", title: "第九章 重逢的路口", summary: "多年后在熟悉的路口重逢，彼此都变了模样，却还认得出对方的脚步声。", tags: ["重逢", "情绪"], meta: "约 3700 字 · 连载中", status: "已更新" },
  { id: "n10", title: "第十章 年节里的团圆", summary: "年关将至，一家人重新坐满那张桌子，筷子声里都是失而复得的踏实。", tags: ["团圆", "群像"], meta: "约 3900 字 · 连载中", status: "已更新" },
  { id: "n11", title: "第十一章 风起的时候", summary: "平静的日子再起波澜，一个突如其来的消息考验着所有人的选择。", tags: ["波折", "抉择"], meta: "约 3600 字 · 连载中", status: "已更新" },
  { id: "n12", title: "第十二章 灯火依旧", summary: "兜兜转转，屋檐下的那盏灯还是亮着，故事在温柔的余韵里告一段落。", tags: ["收束", "温情"], meta: "约 4000 字 · 连载中", status: "最新" },
];

export const dramaEpisodes: LibraryItem[] = [
  { id: "d1", title: "第 1 集 久别重逢", summary: "游子返乡，推开院门的那一刻，嫂子手里还端着刚出锅的热菜。", tags: ["开篇", "重逢"], meta: "约 3 分钟", status: "已更新" },
  { id: "d2", title: "第 2 集 一桌家常饭", summary: "久违的一桌菜摆上桌，热闹之下每个人心里都揣着各自的话。", tags: ["日常", "群像"], meta: "约 3 分钟", status: "已更新" },
  { id: "d3", title: "第 3 集 藏起的体检单", summary: "一张被塞进抽屉深处的体检单，成为全家人心照不宣的秘密。", tags: ["悬念", "线索"], meta: "约 4 分钟", status: "已更新" },
  { id: "d4", title: "第 4 集 借钱这件事", summary: "亲戚上门开口借钱，嫂子的处理方式让在场的人都沉默了。", tags: ["人情", "冲突"], meta: "约 3 分钟", status: "已更新" },
  { id: "d5", title: "第 5 集 误会渐深", summary: "一句话被传来传去变了味，误会像雪球一样越滚越大。", tags: ["误会", "波折"], meta: "约 4 分钟", status: "已更新" },
  { id: "d6", title: "第 6 集 雨中的伞", summary: "大雨里的一把伞递了过去，也把两个人之间的距离拉近了一点。", tags: ["情绪", "转折"], meta: "约 3 分钟", status: "已更新" },
  { id: "d7", title: "第 7 集 老屋修缮", summary: "老屋漏雨需要修缮，凑钱的过程里翻出了一家人的旧账与新账。", tags: ["家庭", "细节"], meta: "约 4 分钟", status: "已更新" },
  { id: "d8", title: "第 8 集 当面对质", summary: "积压的情绪终于当面摊开，争吵之后是长久的安静。", tags: ["高潮", "冲突"], meta: "约 4 分钟", status: "已更新" },
  { id: "d9", title: "第 9 集 深夜长谈", summary: "熄灯后的院子里，两个人第一次把心里的话说清楚。", tags: ["转折", "情感"], meta: "约 3 分钟", status: "已更新" },
  { id: "d10", title: "第 10 集 冰释前嫌", summary: "说开了的误会变成理解，一家人重新找回从前的默契。", tags: ["和解", "温暖"], meta: "约 3 分钟", status: "已更新" },
  { id: "d11", title: "第 11 集 新的开始", summary: "年轻人决定留在家里一起把日子过好，院门口挂起了新的灯笼。", tags: ["成长", "希望"], meta: "约 4 分钟", status: "已更新" },
  { id: "d12", title: "第 12 集 灯火可亲", summary: "故事收尾，炊烟、灯火与一家人，成了最让人安心的画面。", tags: ["收官", "温情"], meta: "约 4 分钟", status: "最新" },
];

export const comicChapters: LibraryItem[] = [
  { id: "c1", title: "第 1 话 屋檐下的灯", summary: "以一幅暖色调的全景开场，把院子和屋里的人一次交代清楚。", tags: ["开篇", "画面"], meta: "共 42 格", status: "已更新" },
  { id: "c2", title: "第 2 话 清晨的粥", summary: "用一格格细节描绘清晨的灶台，把嫂子的性格藏在动作里。", tags: ["日常", "细节"], meta: "共 38 格", status: "已更新" },
  { id: "c3", title: "第 3 话 那道背影", summary: "雨里远去的背影占据整页，留白处理让情绪更浓。", tags: ["情绪", "留白"], meta: "共 40 格", status: "已更新" },
  { id: "c4", title: "第 4 话 沉默的午后", summary: "午后的院子安静得能听见蝉声，沉默本身就是一种对白。", tags: ["氛围", "情绪"], meta: "共 36 格", status: "已更新" },
  { id: "c5", title: "第 5 话 邻里闲谈", summary: "街坊群像登场，画面节奏轻快，补充了不少人物关系。", tags: ["群像", "轻松"], meta: "共 44 格", status: "已更新" },
  { id: "c6", title: "第 6 话 一封信的重量", summary: "信纸特写与回忆插叙交替，把往事一点点铺陈开来。", tags: ["回忆", "线索"], meta: "共 46 格", status: "已更新" },
  { id: "c7", title: "第 7 话 雨中归人", summary: "天气由晴转雨，画面色彩随之变冷，情绪层层推进。", tags: ["转折", "色彩"], meta: "共 41 格", status: "已更新" },
  { id: "c8", title: "第 8 话 说不出口的关心", summary: "用分镜表现欲言又止，一个停顿胜过一堆台词。", tags: ["代际", "情感"], meta: "共 39 格", status: "已更新" },
  { id: "c9", title: "第 9 话 心结", summary: "跨页大格呈现冲突瞬间，把积压的情绪一次性释放。", tags: ["高潮", "冲突"], meta: "共 45 格", status: "已更新" },
  { id: "c10", title: "第 10 话 迟来的拥抱", summary: "收尾一话用暖色收束，让整段故事落在温柔的情绪上。", tags: ["和解", "温情"], meta: "共 43 格", status: "最新" },
];

export const videoResources: LibraryItem[] = [
  { id: "v1", title: "剧情速览 · 三分钟看懂前情", summary: "用三分钟梳理人物关系与主线脉络，适合刚接触这部作品的观众。", tags: ["速览", "入门"], meta: "约 3 分钟", status: "可观看" },
  { id: "v2", title: "名场面回顾 · 灶台边的一句话", summary: "精选原著中最打动人的一段对白，配以画面重现。", tags: ["名场面", "情感"], meta: "约 5 分钟", status: "可观看" },
  { id: "v3", title: "人物志 · 嫂子的日常", summary: "围绕主角的日常片段，看她如何在琐碎里撑起一个家。", tags: ["人物", "日常"], meta: "约 6 分钟", status: "可观看" },
  { id: "v4", title: "分集解说 · 第 1—3 集", summary: "逐集拆解剧情推进与埋下的伏笔，帮助观众理解细节。", tags: ["解说", "剧情"], meta: "约 8 分钟", status: "可观看" },
  { id: "v5", title: "分集解说 · 第 4—6 集", summary: "聚焦误会的产生与化解过程，梳理人物心理变化。", tags: ["解说", "解析"], meta: "约 9 分钟", status: "可观看" },
  { id: "v6", title: "主题混剪 · 人间烟火", summary: "以炊烟、灯火与饭菜为线索，串联起整部作品的温度。", tags: ["混剪", "主题"], meta: "约 4 分钟", status: "可观看" },
  { id: "v7", title: "幕后花絮 · 拍摄日常", summary: "记录拍摄现场的点滴，看看镜头之外的故事氛围。", tags: ["花絮", "轻松"], meta: "约 5 分钟", status: "可观看" },
  { id: "v8", title: "观众留言精选合辑", summary: "整理观众对关键情节的讨论与感受，呈现不同视角。", tags: ["互动", "精选"], meta: "约 6 分钟", status: "可观看" },
];

export const formats: FormatItem[] = [
  {
    id: "f-novel",
    name: "小说",
    icon: "ri-book-2-line",
    carrier: "文字连载",
    feature: "情节完整，心理与细节描写最充分",
    audience: "喜欢慢慢品读、追更的读者",
    tip: "建议按章节顺序阅读，便于理解伏笔",
    image: "https://readdy.ai/api/search-image?query=Warm%20toned%20painterly%20illustration%20of%20an%20open%20book%20resting%20on%20a%20wooden%20table%20beside%20a%20cup%20of%20tea%2C%20soft%20amber%20light%2C%20quiet%20reading%20atmosphere%2C%20textured%20brush%20strokes%2C%20no%20text&width=600&height=420&seq=format-novel-01&orientation=landscape",
  },
  {
    id: "f-drama",
    name: "短剧",
    icon: "ri-movie-2-line",
    carrier: "竖屏剧集",
    feature: "节奏明快，单集时长短，情节推进直接",
    audience: "习惯碎片时间追剧的观众",
    tip: "从第 1 集顺序追，情绪连贯不掉线",
    image: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20illustration%20of%20a%20vertical%20phone%20screen%20playing%20a%20short%20drama%2C%20warm%20amber%20and%20terracotta%20color%20tones%2C%20cozy%20evening%20room%2C%20soft%20glow%2C%20painterly%20texture%2C%20no%20text&width=600&height=420&seq=format-drama-01&orientation=landscape",
  },
  {
    id: "f-comic",
    name: "漫画",
    icon: "ri-image-2-line",
    carrier: "条漫 / 页漫",
    feature: "画面直观，分镜与色彩强化氛围",
    audience: "偏爱视觉呈现、看图入门的读者",
    tip: "可与小说对照，感受同段情节的不同表达",
    image: "https://readdy.ai/api/search-image?query=Warm%20illustrated%20comic%20panel%20layout%20showing%20a%20cozy%20courtyard%20house%2C%20golden%20and%20clay%20tones%2C%20soft%20shading%2C%20storyboard%20style%2C%20gentle%20nostalgic%20mood%2C%20no%20text&width=600&height=420&seq=format-comic-01&orientation=landscape",
  },
  {
    id: "f-video",
    name: "视频",
    icon: "ri-play-circle-line",
    carrier: "解说 / 混剪",
    feature: "浓缩主线，适合快速回顾与了解剧情",
    audience: "想短时间掌握剧情的观众",
    tip: "先看速览，再用目录定位具体章节",
    image: "https://readdy.ai/api/search-image?query=Warm%20toned%20illustration%20of%20a%20video%20play%20button%20over%20a%20soft%20sunset%20countryside%20scene%2C%20amber%20and%20olive%20tones%2C%20painterly%20texture%2C%20calm%20atmosphere%2C%20no%20text&width=600&height=420&seq=format-video-01&orientation=landscape",
  },
];

export const characters: CharacterItem[] = [
  {
    id: "ch1",
    role: "嫂子（主角）",
    trait: "温和、周全、能扛事",
    detail: "家里的主心骨，遇事总是先想着别人，把关心落在一顿饭、一盏灯这样的细节里。",
    image: "https://readdy.ai/api/search-image?query=Warm%20painterly%20illustration%20portrait%20of%20a%20kind%20middle%20aged%20Chinese%20woman%20in%20a%20simple%20apron%20standing%20near%20a%20warm%20kitchen%20door%2C%20golden%20amber%20light%2C%20soft%20brushstrokes%2C%20gentle%20expression%2C%20no%20text&width=520&height=620&seq=char-sister-01&orientation=portrait",
  },
  {
    id: "ch2",
    role: "弟弟（返乡青年）",
    trait: "年少气盛、逐渐成熟",
    detail: "带着外面的见识回到家中，在一次次摩擦里慢慢读懂家人的付出与沉默。",
    image: "https://readdy.ai/api/search-image?query=Warm%20painterly%20illustration%20portrait%20of%20a%20young%20Chinese%20man%20with%20a%20travel%20bag%20standing%20at%20a%20courtyard%20gate%2C%20soft%20amber%20afternoon%20light%2C%20gentle%20brushstrokes%2C%20thoughtful%20mood%2C%20no%20text&width=520&height=620&seq=char-brother-01&orientation=portrait",
  },
  {
    id: "ch3",
    role: "母亲",
    trait: "含蓄、内敛、把爱藏在细节里",
    detail: "话不多，却总在细节里操心，一句淡淡的叮嘱背后是化不开的牵挂。",
    image: "https://readdy.ai/api/search-image?query=Warm%20painterly%20illustration%20portrait%20of%20an%20elderly%20Chinese%20woman%20sitting%20by%20a%20window%20doing%20needlework%2C%20soft%20golden%20light%2C%20quiet%20gentle%20atmosphere%2C%20textured%20brushstrokes%2C%20no%20text&width=520&height=620&seq=char-mother-01&orientation=portrait",
  },
  {
    id: "ch4",
    role: "邻居大姐",
    trait: "热心、直爽、消息灵通",
    detail: "街坊里的人情润滑剂，闲话与帮忙都少不了她，让故事多了几分生活气。",
    image: "https://readdy.ai/api/search-image?query=Warm%20painterly%20illustration%20portrait%20of%20a%20cheerful%20Chinese%20woman%20carrying%20a%20basket%20of%20vegetables%20in%20an%20alley%2C%20warm%20clay%20and%20amber%20tones%2C%20friendly%20smile%2C%20soft%20brushstrokes%2C%20no%20text&width=520&height=620&seq=char-neighbor-01&orientation=portrait",
  },
];

export const guideSteps: StepItem[] = [
  { id: "g1", step: "01", title: "先读简介，理清背景", detail: "花两分钟看完作品简介与人物小传，了解故事的核心关系与情感基调，后面看任何形式都会更顺。" },
  { id: "g2", step: "02", title: "按习惯选一种形式入门", detail: "喜欢文字就从小说目录开始；习惯碎片时间就看短剧；偏爱画面就先翻漫画，不必四种都从头追。" },
  { id: "g3", step: "03", title: "顺着目录从前往后看", detail: "内容目录按作品顺序排列，已更新条目可以一次看完，最新的一章会标注出来，方便衔接。" },
  { id: "g4", step: "04", title: "想回顾就看视频解说", detail: "中间断更或者隔太久忘了剧情，可以用解说与混剪快速捡回主线，再回到目录定位具体章节。" },
  { id: "g5", step: "05", title: "关注目录整理动态", detail: "新增或整理好的条目会集中列在动态区，收藏本页就能第一时间知道该从哪一条接着看。" },
];

export const guideTips: string[] = [
  "四种形式内容方向一致，但侧重不同，建议以小说为底、漫画补画面感。",
  "短剧与视频适合通勤、午休等碎片场景，单条时间短，随开随看。",
  "用内容目录里的搜索框输入关键词，可以快速定位想看的章节或剧集。",
  "把本页加入书签，更新动态区会汇总最近整理好的条目。",
];

export const updateLog: UpdateItem[] = [
  { id: "u1", date: "10 月 10 日", category: "小说", title: "第十二章《灯火依旧》整理上线", detail: "对应作品的最新章节，已并入小说目录，标注为最新。" },
  { id: "u2", date: "10 月 08 日", category: "短剧", title: "第 11—12 集目录补齐", detail: "短剧目录已完整覆盖到收官集，顺序与作品一致。" },
  { id: "u3", date: "10 月 05 日", category: "漫画", title: "第 9—10 话整理完成", detail: "漫画目录补充至第 10 话，并统一了每话的格数标注。" },
  { id: "u4", date: "10 月 02 日", category: "视频", title: "新增名场面回顾《灶台边的一句话》", detail: "视频资源区新收录一条聚焦名场面的解说内容。" },
  { id: "u5", date: "9 月 28 日", category: "人物", title: "补充邻居大姐人物小传", detail: "人物小传增加一条，补齐主要配角的介绍。" },
];

export const faqs: FaqItem[] = [
  { id: "q1", question: "本站提供的是什么内容？", answer: "本站是围绕《善良的嫂子》这一作品的内容导航页，集中整理小说、短剧、漫画、视频四种形式的目录、简介与观看建议，帮助读者和观众按自己的习惯快速定位想看的内容。" },
  { id: "q2", question: "浏览需要注册或付费吗？", answer: "不需要。本站仅提供信息浏览与本地筛选，不涉及账号注册、支付或其他需要提交个人信息的环节，所有内容都可以直接在本页查看。" },
  { id: "q3", question: "四种形式的内容完全一样吗？", answer: "大方向是一致的，都围绕同一条主线与同一批人物展开，但呈现方式各有侧重：小说细节最全，短剧节奏最快，漫画画面感强，视频则更适合快速回顾。建议对照着看，会有不同的感受。" },
  { id: "q4", question: "怎么快速找到最新章节或最新剧集？", answer: "有两个办法：一是查看「目录整理动态」，最近整理好的条目都会集中列在那里；二是在内容目录的搜索框里输入关键词，当前分类下的相关条目会即时筛选出来。" },
  { id: "q5", question: "内容目录里的顺序有什么讲究吗？", answer: "目录默认按作品本身的先后顺序排列，方便从头往后追。已更新的条目标注为「已更新」，最新的一条会标注为「最新」，让你一眼就能知道该从哪一条接着看。" },
];